export default {
	title: (mode, type) => `${mode} định mức chi phí theo hóa đơn - ${type}`,
	FromDate: 'Từ ngày',
	ToDate: 'Đến ngày',
	Quota: 'Định mức',
	AddCostType: 'Thêm định mức chi phí',
	EditCostType: 'Sửa định mức chi phí',
	PlaceholderNormsAccordingToInvoice: 'Nhập số tiền',
	MaxNumberDetailNorms: 'Không thể thêm dòng do chương trình chỉ đáp ứng tối đa 20 dòng định mức.',
	WarningUpdateCostTypeInvoices: 'Chương trình chỉ thực hiện Cập nhật định mức chi phí với các hóa đơn được phân loại chi phí và không phải hóa đơn chiết khấu/bị hủy/bị thay thế.',
	ListClassificationInvoiceDetailEmpty: type =>
		`Không có định mức nào được thiết lập cho loại chi phí ${type}. Bạn có muốn lưu không?`,
	UpdateClassificationInvoiceDetailWarning: href =>
		`<div>Các hóa đơn đã vào chương trình sẽ không tự động cập nhật lại định mức chi phí mới. Bạn cần nhấn Cập nhật định mức chi phí cho các hóa đơn cũ. <a href=${href} target="_blank">Xem hướng dẫn</a></div>`,

	UpdateCostTypeInvoiceByTimeTitle: (mode, name) => `${mode} định mức chi phí theo thời gian - ${name}`,
	ChangePeriodWarning: (oldPeriod, newPeriod, costName) => `Các dòng định mức theo ${oldPeriod} sẽ bị xóa khi thay đổi kỳ ${oldPeriod} sang kỳ ${newPeriod}. Bạn có chắc chắn muốn sửa kỳ định mức đối với loại chi phí ${costName} không?`,
};
